import React from "react";
import theme from "../../theme/theme";

const SidebarFooter = () => {
  const { website, websiteLabel, companyName, name, showDevelopedBy } = theme.brand;
  return (
    <div className="siderbar_footer">
      © {new Date().getFullYear()}{" "}
      <a href={website} target="_blank" rel="noreferrer">
        {websiteLabel || website}
      </a>
      {showDevelopedBy && (
        <>
          <br />
          Designed & Developed by
          <br />
          <a href={website} target="_blank" rel="noreferrer">
            {companyName || name}.
          </a>
        </>
      )}
    </div>
  );
};

export default SidebarFooter;
